const strict = 'warn';
const unicodeTextInMathMode = true;

const KATEX_INLINE_OPTS = {
  strict: strict,
  unicodeTextInMathMode: unicodeTextInMathMode,
};
const KATEX_BLOCK_OPTS = {
  displayMode: true,
  strict: strict,
  unicodeTextInMathMode: unicodeTextInMathMode,
};

module.exports = {
  inline: KATEX_INLINE_OPTS,
  block: KATEX_BLOCK_OPTS,
};
